import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateUtils {



    get idiomaEspanol() {
        return {
            firstDayOfWeek: 0,
            dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
            dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            today: 'Hoy',
            clear: 'Limpiar',
            dateFormat: 'dd/MM/yyyy HH:mm',
            weekHeader: 'Wk'
        };
    }
    /**
     * Obtiene la fecha actual con el formato yyyy-mm-dd hh:mm:ss.
     */
    public obtenerFechaActualConFormatoAnioMesDiaHr(): string {
        let fecha = new Date();
        let fechaConFormato: string = fecha.getFullYear() + "-" + (fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds()
        return fechaConFormato;
    }

    public obtenerFechaConFormato(dt: Date | number | string): string {
        if (typeof dt === 'number') {
            dt = new Date(dt);
        } else if (typeof dt === 'string') {
            dt = new Date(parseInt(dt));
        }
        return `${dt.getFullYear().toString().padStart(4, '0')}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')} ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`;
    }
}
